var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { makeAutoObservable } from "mobx";
import { perRestaurant } from "../../di";
import { ExtraFeeService } from "../ExtraFeeService";
import { Money } from "../../core";
let ExtraFeePriceService = class ExtraFeePriceService {
    constructor(extraFeeService) {
        this.extraFeeService = extraFeeService;
        makeAutoObservable(this);
    }
    depositValue(depositFeeRate) {
        switch (depositFeeRate) {
            case "SingleUsePlasticBottle":
            case "MetalCan":
                return Money.fromCents(50);
            case "MultiUseGlassBottle":
                return Money.fromCents(100);
        }
    }
    get depositTotal() {
        return Money.total(this.extraFeeService.extraFees.mapOptional((packagingFeeInstance) => {
            const { deposit } = packagingFeeInstance.packagingFeeType;
            if (deposit === null) {
                return null;
            }
            return this.depositValue(deposit).multiply(packagingFeeInstance.quantity);
        }));
    }
};
ExtraFeePriceService = __decorate([
    perRestaurant(),
    __metadata("design:paramtypes", [typeof (_a = typeof ExtraFeeService !== "undefined" && ExtraFeeService) === "function" ? _a : Object])
], ExtraFeePriceService);
export { ExtraFeePriceService };
